<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4dr54Y/tc-custom/9781641083683.jpg?1711126281437" alt="This image is the cover for the book Fauteur de troubles, Série 415 Ink"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fauteur de troubles, Série 415 Ink
      </h1>
      <p class="bookDescription body article font2">
        <p>Quand l’inspecteur Ruan Nicholls rencontre Ivo Rogers, il sait immédiatement que ce jeune tatoueur va bouleverser sa vie bien rangée. Fauteur de troubles par nature, Ivo est quelqu’un que Ruan non seulement ne comprend pas, mais qu’il n’est pas sûr de vouloir comprendre. Tout chez Ivo est plein de vie, impétueux, prétentieux et arrogant, mais Ruan ne veut rien de lui.<br/><br/>Ou du moins, c’est le mensonge qu’il se répète pour amoindrir le désir qu’il éprouve pour cet enfant terrible, issu des services sociaux, que le destin a placé au travers de sa route.<br/><br/>Deux choses importent dans la vie d’Ivo Rogers : sa famille et 415 Ink, le salon de tatouage qu’il a fondé avec ses quatre frères. Si sa famille porte encore des cicatrices après s’être battue contre les services sociaux pendant de nombreuses années, le lien qui existe entre eux est fort, assez pour soutenir Ivo dans les moments difficiles.<br/><br/>Mais voilà que ce dernier doit faire face à un nouveau défi quand il tombe amoureux d’un policier de la vieille école, qui a des idées reçues sur ce à quoi un homme doit ressembler. Ruan incarne la promesse d’une vie qu’Ivo n’aurait jamais pensé avoir un jour, mais leurs manières opposées de voir le monde menacent toute chance d’une relation entre eux. Il est facile d’être mal compris quand on est le fauteur de troubles de la famille, mais Ivo a confiance en Ruan : celui-ci saura accepter qui il est et l’aimer comme il le mérite.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhys Ford, Enzo Daumier
      </h2>
      
      <p class="authorDescription body article">&#160;Rhys Ford is an award-winning author with several long-running LGBT+ mystery, thriller, paranormal, and urban fantasy series and is a two-time LAMBDA finalist with her Murder and Mayhem novels. She is also a 2017 Gold and Silver Medal winner in the Florida Authors and Publishers President&rsquo;s Book Awards for her novels <I>Ink and Shadows</I> and <I>Hanging the Stars</I>. She is published by Dreamspinner Press and DSP Publications.<BR />She shares the house with Harley, a gray tuxedo with a flower on her face, Badger, a disgruntled alley cat who isn&rsquo;t sure living inside is a step up the social ladder, as well as a ginger cairn terrorist named Gus. Rhys is also enslaved to the upkeep of a 1979 Pontiac Firebird and enjoys murdering make-believe people.<BR />Rhys can be found at the following locations:<BR />Blog: www.rhysford.com<BR />Facebook: www.facebook.com/rhys.ford.author<BR />Twitter: @Rhys_Ford<BR />&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2383b5b2